import React from 'react';
import { Routes, Route } from 'react-router-dom';

// import useGlobalState from 'Hooks/useGlobalState';

import FooterMenu from 'Components/FooterMenu';
import AdminMenu from 'Components/AdminMenu';
// import AdminOrganisations from './AdminOrganisations';
import AdminOrganisationEdit from './AdminOrganisationEdit';
import AdminOrganisationAdd from './AdminOrganisationAdd';
import AdminOrganisation from './AdminOrganisation';
import AdminMain from './AdminMain';
import AdminBuildingAdd from './AdminBuildingAdd';
import AdminBuildingEdit from './AdminBuildingEdit';
import AdminUserAdd from './AdminUserAdd';
import AdminUserEdit from './AdminUserEdit';
import AdminMoveDevices from './AdminMoveDevices';
import AdminExportData from './AdminExportData';
import AdminNotifications from './AdminNotifications';

const Admin = ({ children }) => {

return (<>
		<AdminMenu title='Administration' />
		{children}
		<Routes>
			{/* <Route path="/organisation" element={<AdminOrganisations />}></Route> */}
			<Route path="/organisation/:uuid" element={<AdminOrganisation />}></Route>
			<Route path="/organisation/:uuid/edit" element={<AdminOrganisationEdit />}></Route>
			<Route path="/organisation/:uuid/add" element={<AdminOrganisationAdd />}></Route>
			<Route path="/organisation/:uuid/addbuilding" element={<AdminBuildingAdd />}></Route>
			<Route path="/organisation/:uuid/editbuilding/:buildinguuid" element={<AdminBuildingEdit />}></Route>
			<Route path="/organisation/:uuid/adduser" element={<AdminUserAdd />}></Route>
			<Route path="/organisation/:uuid/edituser/:useruuid" element={<AdminUserEdit />}></Route>
			<Route path="/organisation/:uuid/movedevices" element={<AdminMoveDevices />}></Route>
			<Route path="/organisation/:uuid/exportdata" element={<AdminExportData />}></Route>
			<Route path="/organisation/:uuid/notifications" element={<AdminNotifications />}></Route>
			<Route path="/organisation/:uuid/notifications/:notificationId" element={<AdminNotifications />}></Route>
			{/* <Route path="/building/:uuid/edit" element={<AdminOrganisationAdd />}></Route> */}
			<Route path="" element={<AdminMain />}></Route>
		</Routes>
		<FooterMenu activeMenu={2} />
	</>
	);
};

export default Admin;